import { ActivatedRouteSnapshot } from '@angular/router';
import { AbstractControl } from '@angular/forms';

export function getRequiredParam(route: ActivatedRouteSnapshot, key: string): string {
  const value = route.paramMap.get(key);
  if (value === null) {
    throw new Error(`Required route param "${key}" is missing`);
  }
  return value;
}

export function getRequiredControl(form: AbstractControl, path: string): AbstractControl {
  const control = form.get(path);
  if (control === null) {
    throw new Error(`Required form control "${path}" is missing`);
  }
  return control;
}
